import { LoggerError } from '@rehaje/errors'

import type { Locales } from '@rehaje/errors'

export class LoggerMigrationError extends LoggerError {
  static override locales: Locales = {
    'en-US': 'Migration from %s version to %s version failed %s',
    'zh-CN': '从 %s 版本迁移到 %s 版本发生错误 %s',
    'zh-HK': '從 %s 版本迁移到 %s 版本發生錯誤 %s'
  }

  override name = 'LoggerMigrationError' as const

  constructor(fromVersion: string, toVersion: string, message: string) {
    super(fromVersion, toVersion, message)
  }
}
